import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDown,
  faAngleRight,
  faBars,
  faFileAlt,
  faThLarge,
  faFile,
  faUser,
  faLock,
  faAngleUp,
  faCalendarAlt,
  faPlusSquare,
  faTasks,
  faSearch,
  faCogs,
  faPaperclip,
  faSignOutAlt,
  faEye,
  faUserClock,
  faPlus,
  faTrashAlt,
  faExclamationTriangle,
  faHistory,
  faEllipsisV,
  faEdit,
  faClock,
  faBell,
  faCaretUp,
  faCaretDown,
  faCheck,
  faDownload,
  faReply,
  faChartLine,
  faBook,
  faHome,
  faFolderOpen,
  faUsers,
  faPlusCircle,
  faRecycle,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faKey,
  faShare,
  faUpload,
  faSync,
  faExchangeAlt,
  faCircle,
  faBan,
  faPencilAlt,
  faSlidersH,
  faAddressCard,
  faPaperPlane,
  faListAlt,
  faWrench,
  faCog,
  faCity,
  faFileSignature,
  faClone,
  faPenAlt,
  faLightbulb,
  faCheckCircle,
  faInfoCircle,
  faCheckSquare,
  faComments,
  faSyncAlt,
  faTags,
  faCommentDots,
  faFileExcel,
  faFilePdf,
  faUndo,
  faRedo,
  faWindowClose,
  faAngleLeft,
  faStar,
  faTimesCircle,
  faPenSquare,
  faTrash,
  faSignature,
  faCopy,
  faEyeSlash,
  faExclamation,
  faMinus,
  faTimes,
  faNewspaper,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faInfoCircle,
  faThLarge,
  faAngleDown,
  faAngleRight,
  faBars,
  faFileAlt,
  faFile,
  faUser,
  faLock,
  faAngleUp,
  faCalendarAlt,
  faPlusSquare,
  faTasks,
  faSearch,
  faCogs,
  faPaperclip,
  faSignOutAlt,
  faEye,
  faEyeSlash,
  faUserClock,
  faPlus,
  faTrashAlt,
  faExclamationTriangle,
  faHistory,
  faEllipsisV,
  faEdit,
  faClock,
  faBell,
  faCaretUp,
  faCaretDown,
  faCheck,
  faDownload,
  faReply,
  faChartLine,
  faBook,
  faHome,
  faFolderOpen,
  faUsers,
  faPlusCircle,
  faRecycle,
  faShare,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faKey,
  faUpload,
  faSync,
  faExchangeAlt,
  faCircle,
  faBan,
  faPencilAlt,
  faSlidersH,
  faAddressCard,
  faPaperPlane,
  faListAlt,
  faWrench,
  faCog,
  faCity,
  faFileSignature,
  faCog,
  faClone,
  faPenAlt,
  faLightbulb,
  faCheckCircle,
  faCheckSquare,
  faComments,
  faSyncAlt,
  faTags,
  faCommentDots,
  faFileExcel,
  faFilePdf,
  faPaperPlane,
  faUndo,
  faRedo,
  faWindowClose,
  faAngleLeft,
  faStar,
  faTimesCircle,
  faPenSquare,
  faTrash,
  faSignature,
  faCopy,
  faExclamation,
  faMinus,
  faTimes,
  faNewspaper,
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
